import { ActionSubTypes } from '../../../../actions/ActionSubTypes';
import ApiBaseReducer from '../../../core/ApiBaseReducer';
import pList from '../../../../api/models/pList';
import { rYurtDisiTasinmazlariGenelBilgi } from '../../../../api/models/.catalog';
import { DefaultInputDataStateModel, IInputDataStateModel } from '../../../../models/StateModels';

export default ApiBaseReducer<
  pList,
  IInputDataStateModel<pList, rYurtDisiTasinmazlariGenelBilgi>,
  rYurtDisiTasinmazlariGenelBilgi
>(
  ActionSubTypes.API_YURTDISITASINMAZGENELBILGI,
  DefaultInputDataStateModel<pList, rYurtDisiTasinmazlariGenelBilgi>()
);
